import { render, staticRenderFns } from "./ModelOneDetail.vue?vue&type=template&id=8b136856&scoped=true"
import script from "./ModelOneDetail.vue?vue&type=script&lang=js"
export * from "./ModelOneDetail.vue?vue&type=script&lang=js"
import style0 from "./ModelOneDetail.vue?vue&type=style&index=0&id=8b136856&prod&scoped=true&lang=css"
import style1 from "./ModelOneDetail.vue?vue&type=style&index=1&id=8b136856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b136856",
  null
  
)

export default component.exports